import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Cache public site settings for the page lifetime. The SEO component reads the
// live shipping rates + return policy from here to build accurate structured data.
let cache = null;
let inflight = null;

export function fetchStoreSettings() {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = axios
      .get(`${API}/settings`)
      .then((r) => {
        cache = r.data || {};
        return cache;
      })
      .catch(() => ({}));
  }
  return inflight;
}

export function clearStoreSettingsCache() {
  cache = null;
  inflight = null;
}
